import { observer } from "mobx-react";
import { NoBusinessManagerForm } from "./noBusinessManagerDomain";
import { Alert } from "@/components-v2/Alert";
import { useState } from "react";
import { LinkButton } from "@/components-v2/Button";
import { VBox } from "@/components-v2/Box";
import { formatOrgNum } from "@/utils/other";

import { useTranslation } from "@/stores/RootStoreContext";

export const NoBusinessManagerFormView = observer(function NoBusinessManagerFormView({
  form,
}: {
  form: NoBusinessManagerForm;
}) {
  const { t } = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const currentBusinessManager = form.data?.previousBusinessManager ?? form.previousBusinessManager;
  const orgNoPrefix = t("decisions.changeOfBusinessManager.orgNoPrefix");
  return form.hasBusinessManager ? (
    <VBox gap={"md"}>
      {currentBusinessManager && (
        <div>
          <div>{t("decisions.changeOfBusinessManager.company-business-manager-now")}</div>
          {`${currentBusinessManager.name} (${orgNoPrefix} ${formatOrgNum(
            currentBusinessManager.organisationNumber,
          )})`}
        </div>
      )}
      {showMore ? (
        <div className={"content"}>
          <div>{t("decisionType.noBusinessManager.text")}</div>
          <LinkButton label={t("list.showLess")} onClick={() => setShowMore(false)} />
        </div>
      ) : (
        <div>
          {t("decisionType.noBusinessManager.text").slice(0, 40)}
          {"..."}
          <LinkButton label={t("list.showMore")} onClick={() => setShowMore(true)} />
        </div>
      )}
    </VBox>
  ) : (
    <div>
      <Alert
        message={t("decisionType.noBusinessManager.companyHasNoBusinessManager")}
        type={"warning"}
      />
    </div>
  );
});
